/*
 * @Author: your name
 * @Date: 2019-12-26 17:08:49
 * @LastEditTime : 2019-12-30 10:22:28
 * @LastEditors  : Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /xingmahui_front/src/utils/mockData/harvardData.js
 */
export default{
    expertList:[
        {
            "id":0,
            "name":'Elise M.Taveras',
            "imgUrl":"https://image-mom.feihe.com/harvard/expert/Elise-M.Taveras.png",
            "info":"儿科医生，医学博士， 哈佛医学院儿科学教授和哈佛大学陈氏公共卫生学院营养系教授，哈佛大学公共卫生学院的公共卫生硕士",
            "level":"哈佛大学医学院婴儿营养学教授"
        },
        {
            "id":1,
            "name":'Brodsky',
            "imgUrl":"https://image-mom.feihe.com/harvard/expert/Brodsky.png",
            "info":"新生儿科医生，BIDMC新生儿重症监护病房副主任，BIDMC新生儿科教育主任，哈佛医学院（HMS）儿科副教授。 目前是AAP在线期刊NeoReviews的主编。",
            "level":"哈佛医学院（HMS）儿科副教授"
        },
        {
            "id":2,
            "name":'Camilia R. Martin',
            "imgUrl":"https://image-mom.feihe.com/harvard/expert/Camilia-R.-Martin.png",
            "info":"哈佛医学院儿科学副教授，新生儿重症监护室副主任，哈佛大学公共卫生学院流行病学硕士。",
            "level":"哈佛医学院儿科学副教授"
        },
        {
            "id":3,
            "name":'Claire Zar-Kessler',
            "imgUrl":"https://image-mom.feihe.com/harvard/expert/Claire-Zar-Kessler.png",
            "info":"毕业于纽约阿尔伯特•爱因斯坦医学院，后来到MGH完成儿科胃肠病学研究。重点研究运动和功能性紊乱，特别是慢性腹痛和儿童便秘的治疗。",
            "level":"马萨诸塞州儿童总医院儿科主任"
        },
        {
            "id":4,
            "name":'Maureen Leonard',
            "imgUrl":"https://image-mom.feihe.com/harvard/expert/Maureen-Leonard.png",
            "info":"哈佛医学院儿科讲师，麻省儿童总医院乳糜泻研究与治疗中心临床主任，得到哈佛大学营养肥胖研究中心和NIH（FDK109620A）的资助。经常诊疗患乳糜泻、非乳糜泻谷蛋白敏感性和其他谷蛋白相关疾病成人和儿童。",
            "level":"哈佛医学院儿科讲师"
        },
        {
            "id":5,
            "name":'Victoria Martin',
            "imgUrl":"https://image-mom.feihe.com/harvard/expert/Victoria-Martin.png",
            "info":"麻省儿童总医院小儿胃肠病、肝病和营养科的小儿胃肠病学家，哈佛医学院的儿科学讲师。发表过多篇文章，其科研和教学都获得了多个奖项。",
            "level":"哈佛医学院的儿科学讲师"
        },
        {
            "id":6,
            "name":'Lauren Fiechtner',
            "imgUrl":"https://image-mom.feihe.com/harvard/expert/Lauren-Fiechtner.png",
            "info":"麻省儿童总医院胃肠病学和营养学部营养主任，在哈佛大学公共卫生学院获得了公共卫生硕士学位。她的研究成果发表在多个期刊上，包括美国公共卫生杂志，儿童肥胖和预防医学杂志。",
            "level":"哈佛大学公共卫生学硕士"
        }
    ]
}